export default "__VITE_ASSET__B9dZ_DXY__"